import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Component_CollectionGrid, ComponentSync, LL_H_C, LL_V_L, ModuleFE_Dialog, ModuleFE_MouseInteractivity, ModuleFE_SyncManager, ModuleFE_Thunderstorm, TS_CollapsableContainer, TS_Input, TS_Toggle } from '@nu-art/thunderstorm-frontend/index';
import './Menu_AdvisorSettings.scss';
import { ICONS } from '@app/styles';
import { Renderer_RowWrapper } from './renderers/Renderer_RowWrapepr/Renderer_RowWrapper.js';
import { advisorConfig_DevMode, advisorConfig_EnableKickstart, advisorConfig_HideNegative, advisorConfig_NumberOfKickstartQuestions, advisorConfig_ShowOrderSetProtocols, ModuleFE_AdvisorSettings, } from '../../../modules/ModuleFE_AdvisorSettings/index.js';
import { Renderer_RunAction } from './renderers/Renderer_RunAction/Renderer_RunAction.js';
import { ModuleFE_AdvisorSession, ModuleFE_EMInterface, ModuleFE_EncounterMetadata, ModulePackFE_Advisor_Runtime, Page_SandboxFHIR, Page_SandboxOrder } from '@app/advisor-frontend';
import { AdvisorButton_VersionUpdate } from './AdvisorButton_VersionUpdate.js';
import { Dialog_DBExplorer } from '@app/advisor-debug-frontend';
import { ModuleFE_Spotlight } from '../../../modules/ModuleFE_Spotlight/index.js';
import { DefaultKickstartVariables, DispositionRecommendedAction } from '@app/advisor-shared';
import { defaultAdvisorBoard, MiddleColumn_Full, MiddleColumn_TwoThirdsLeft, MiddleColumn_TwoThirdsRight, } from '@app/advisor-v5-shared';
import { makeItDance } from './make-it-dance.js';
import { Dialog_ClearEncounter } from './clear-encounter-dialog/Dialog_ClearEncounterDialog.js';
import { ModuleFE_AdvisorBoard } from '../../../_enum/advisor-board/index.js';
import { Storage_AppVersion } from '@nu-art/thunderstorm-frontend';
import { Toaster_AdvisorGeneral } from '../../pages/toast.js';
import { exists, Second } from '@nu-art/ts-common';
import { StorageKey_SnapShotVersion } from '@app/advisor-frontend/index';
import { Dialog_Recap } from '../../dialogs/Dialog_Recap/Dialog_Recap.js';
import { ModuleFE_Recap } from '../../../modules/ModuleFE_Recap/ModuleFE_Recap.js';
import { ModuleFE_AdvisorAnalytics } from '../../../_analytics/consts.js';
import { ABTestValue } from '@app/org-shared';
import { ModuleFE_AdvisorABTesting } from '../../../modules/ModuleFE_AdvisorSettings/ModuleFE_AdvisorABTesting.js';
const panelModes = [
    { key: defaultAdvisorBoard, label: 'Reset Panel width', type: 'column-width' },
    { key: MiddleColumn_Full, label: 'Middle panel full', type: 'column-width' },
    { key: MiddleColumn_TwoThirdsLeft, label: 'Middle panel left', type: 'column-width' },
    { key: MiddleColumn_TwoThirdsRight, label: 'Middle panel right', type: 'column-width' },
];
export class Menu_AdvisorSettings extends ComponentSync {
    //######################### Life Cycle #########################
    __onAdvisorSettingsUpdated = (key) => this.forceUpdate();
    __onSessionUpdated() {
        this.reDeriveState();
    }
    __onLoadingInitialData() {
        this.reDeriveState();
    }
    deriveStateFromProps(nextProps, state) {
        state.readonly = ModuleFE_EMInterface.isLoadingInitialData();
        return state;
    }
    static show() {
        ModuleFE_AdvisorAnalytics.trigger.settings.settings_open();
        ModuleFE_Dialog.show({ content: _jsx(Menu_AdvisorSettings, {}), closeOverlayOnClick: () => true });
    }
    //######################### Logic #########################
    closeMenu = () => {
        ModuleFE_Dialog.close();
    };
    setWorkspace = (ratios, type) => {
        this.closeMenu();
        if (type === 'panel')
            return;
        else
            return setTimeout(() => ModuleFE_AdvisorBoard.updateColumnsWidth(ratios), 500);
    };
    openSandbox = (sandboxType) => {
        let sandboxToRender;
        if (sandboxType === 'epic')
            sandboxToRender = _jsx(Page_SandboxOrder, {});
        else if (sandboxType === 'fhir-sandbox')
            sandboxToRender = _jsx(Page_SandboxFHIR, {});
        ModuleFE_MouseInteractivity.hide('pop-up');
        ModuleFE_Dialog.show({
            content: _jsx("div", { className: 'advisor-sandbox-dialog', children: sandboxToRender }),
            closeOverlayOnClick: () => true
        });
    };
    clearEncounter = async () => {
        ModuleFE_SyncManager.stopListening();
        await Promise.all([
            ModuleFE_EMInterface.vv1.encounter.clearEncounterState({}).executeSync(),
            ModuleFE_AdvisorSettings.clearEncounterCache(ModuleFE_AdvisorSession.getCurrentEncounterId())
        ]);
        this.closeMenu();
        Dialog_ClearEncounter.show('Encounter cleared successfully!');
    };
    endEncounter = async () => {
        await ModuleFE_EMInterface.vv1.encounter.endEncounter({
            dispositionAction: DispositionRecommendedAction.ENGAGED_ENCOUNTER,
        }).executeSync();
        this.closeMenu();
    };
    clearCache = async () => {
        await ModuleFE_Thunderstorm.clearWebsiteData();
        location.reload();
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { id: 'menu__advisor-settings', children: [_jsxs(LL_H_C, { className: 'menu-header', children: [_jsx("p", { children: "Settings" }), _jsx(ICONS.advisor_avn_close.component, { className: 'close-menu', onClick: () => this.closeMenu() })] }), _jsxs(LL_V_L, { className: 'menu-body', children: [this.renderShowAllValues(), this.renderEnableDocumentation(), this.renderEnableAgl(), this.renderSystemActions(), this.render_DevSection(), this.render_ABTesting(), this.renderAdvancedSettings(), this.renderCollectionStats()] }), this.renderVersions()] });
    }
    renderShowAllValues = () => {
        return _jsx(Renderer_RowWrapper, { label: 'Hide Negative Values', direction: 'Horizontal', children: _jsx(TS_Toggle, { checked: ModuleFE_AdvisorSettings.getAdvisorConfig(advisorConfig_HideNegative), onCheck: () => {
                    ModuleFE_AdvisorSettings.toggleHideNegative();
                    this.forceUpdate();
                } }) });
    };
    renderEnableDocumentation = () => {
        if (this.state.readonly)
            return;
        const enableDocumentation = ModuleFE_AdvisorSession.getAdvisorConfig().enableDocumentation;
        return _jsx(Renderer_RowWrapper, { label: 'Enable Documentation', direction: 'Horizontal', children: _jsx("p", { className: 'ghost-text', children: enableDocumentation ? 'Yes' : 'No' }) });
    };
    renderEnableAgl = () => {
        if (this.state.readonly)
            return;
        const enableAgl = ModuleFE_AdvisorSession.getAdvisorConfig().enableAgl;
        return _jsx(Renderer_RowWrapper, { label: 'Enable AGL', direction: 'Horizontal', children: _jsx("p", { className: 'ghost-text', children: enableAgl ? 'Yes' : 'No' }) });
    };
    renderSystemActions = () => {
        const advisorConfig = ModuleFE_EncounterMetadata.getEncounterMetadata()?.advisorConfig;
        const canClearEncounter = !this.state.readonly && advisorConfig?.devInstance && ModuleFE_EMInterface.canCreateBugReport();
        const canClearCache = ModuleFE_EMInterface.isAvatarMode();
        return _jsx(Renderer_RowWrapper, { label: 'System Actions', direction: 'Horizontal', children: _jsxs(LL_H_C, { style: { gap: '8px' }, children: [canClearEncounter && _jsxs(_Fragment, { children: [_jsx(Button, { variant: 'primary', className: 'system-action', onClick: () => this.clearEncounter(), children: "Clear Encounter" }), _jsx(Button, { variant: 'primary', className: 'system-action', onClick: this.endEncounter, children: "End Encounter" })] }), canClearCache &&
                        _jsx(Button, { variant: 'primary', className: 'system-action', onClick: this.clearCache, children: "Clear Cache" })] }) });
    };
    renderVersions = () => {
        const dataVersion = StorageKey_SnapShotVersion.get();
        const appVersion = Storage_AppVersion.get();
        return _jsxs(LL_V_L, { className: 'versions-container', children: [_jsx(AdvisorButton_VersionUpdate, {}), _jsxs(LL_H_C, { className: 'versions', children: [_jsx(Renderer_RowWrapper, { direction: 'Horizontal', label: 'Data Version', children: _jsx("p", { className: 'ghost-text', children: dataVersion }) }), _jsx(Renderer_RowWrapper, { direction: 'Horizontal', label: 'App Version', children: _jsx("p", { className: 'ghost-text', children: appVersion }) })] }), " "] });
    };
    renderAdvancedSettings = () => {
        return _jsx(TS_CollapsableContainer, { flipHeaderOrder: true, customCaret: _jsx(ICONS.advisor_v4_arrow.component, {}), headerRenderer: () => _jsx(_Fragment, { children: "Advanced Settings" }), containerRenderer: () => _jsxs(LL_V_L, { className: 'match_parent', children: [this.renderDevConfiguration(), this.renderSandboxes()] }) });
    };
    renderDevConfiguration = () => {
        return _jsxs(_Fragment, { children: [_jsx(Renderer_RowWrapper, { direction: 'Horizontal', label: 'Dev Mode', children: _jsx(TS_Toggle, { checked: ModuleFE_AdvisorSettings.getAdvisorConfig(advisorConfig_DevMode), onCheck: () => {
                            ModuleFE_AdvisorSettings.toggleDevMode();
                            this.forceUpdate();
                        } }) }), ModuleFE_AdvisorSettings.getAdvisorConfig(advisorConfig_DevMode) &&
                    _jsx(Renderer_RowWrapper, { direction: 'Horizontal', label: 'Show Order-Set Protocols', children: _jsx(TS_Toggle, { checked: ModuleFE_AdvisorSettings.getAdvisorConfig(advisorConfig_ShowOrderSetProtocols), onCheck: () => {
                                ModuleFE_AdvisorSettings.toggleShowOrderSetProtocols();
                                this.forceUpdate();
                            } }) }), !this.state.readonly &&
                    _jsx(Renderer_RowWrapper, { direction: 'Horizontal', label: 'Enable Kickstart', children: _jsx(TS_Toggle, { checked: ModuleFE_AdvisorSettings.getAdvisorConfig(advisorConfig_EnableKickstart), onCheck: () => {
                                ModuleFE_AdvisorSettings.toggleKickstart();
                                this.forceUpdate();
                            } }) }), ModuleFE_AdvisorSettings.getAdvisorConfig(advisorConfig_EnableKickstart)
                    && _jsx(Renderer_RowWrapper, { direction: 'Horizontal', label: 'No. of kickstart questions', children: _jsx(TS_Input, { type: 'number', value: String(ModuleFE_AdvisorSettings.getAdvisorConfig(advisorConfig_NumberOfKickstartQuestions)), onBlur: value => {
                                if (!value)
                                    return ModuleFE_AdvisorSettings.setNumberOfKickstartQuestions(DefaultKickstartVariables);
                                ModuleFE_AdvisorSettings.setNumberOfKickstartQuestions(Number(value));
                                this.forceUpdate();
                            } }) })] });
    };
    renderSandboxes = () => {
        if (this.state.readonly && ModuleFE_EMInterface.getUserType() !== 'avatar-mode')
            return;
        return _jsxs(Renderer_RowWrapper, { label: 'Sandboxes', direction: 'Vertical', children: [_jsx(Renderer_RunAction, { label: 'Epic Sandbox', action: () => this.openSandbox('epic') }), _jsx(Renderer_RunAction, { label: 'FHIR Sandbox', action: () => this.openSandbox('fhir-sandbox') })] });
    };
    renderCollectionStats = () => {
        return _jsx(TS_CollapsableContainer, { flipHeaderOrder: true, customCaret: _jsx(ICONS.advisor_v4_arrow.component, {}), headerRenderer: () => _jsx(_Fragment, { children: "Collection Stats" }), containerRenderer: () => _jsx(Component_CollectionGrid, { modules: [...ModulePackFE_Advisor_Runtime, ModuleFE_EncounterMetadata] }) });
    };
    //######################### Render - DEV #########################
    render_DevSection = () => {
        if (this.state.readonly || !ModuleFE_AdvisorSettings.getAdvisorConfig(advisorConfig_DevMode))
            return;
        return _jsx(TS_CollapsableContainer, { flipHeaderOrder: true, customCaret: _jsx(ICONS.advisor_v4_arrow.component, {}), headerRenderer: () => _jsx(_Fragment, { children: "Dev Settings" }), containerRenderer: () => _jsxs(LL_V_L, { className: 'match_parent', children: [this.renderDevActions(), this.renderWorkspaceTests()] }) });
    };
    renderDevActions = () => {
        return _jsxs(_Fragment, { children: [_jsxs(Renderer_RowWrapper, { direction: 'Vertical', label: 'Dev Actions', children: [_jsx(Renderer_RunAction, { action: () => {
                                this.closeMenu();
                                navigator.storage.estimate().then(estimate => {
                                    this.logInfo(`Quota: ${estimate.quota} bytes`);
                                    this.logInfo(`Usage: ${estimate.usage} bytes`);
                                });
                            }, label: 'Print Memory Quota' }), _jsx(Renderer_RunAction, { label: 'Trigger Pertinent Compute', action: () => {
                                ModuleFE_EMInterface.vv1.encounter.updatePertinentSummary({}).executeSync();
                                this.closeMenu();
                            } }), _jsx(Renderer_RunAction, { action: async () => {
                                ModuleFE_AdvisorSettings.getPertinentDataDump();
                                this.closeMenu();
                            }, label: 'Pertinent Data Dump' }), _jsx(Renderer_RunAction, { action: async () => {
                                await ModuleFE_AdvisorSettings.getFindingsDump();
                                this.closeMenu();
                            }, label: 'Findings Dump' }), _jsx(Renderer_RunAction, { action: async () => {
                                await ModuleFE_AdvisorSettings.getEncounterDataExport();
                                this.closeMenu();
                            }, label: 'Export Encounter Data Excel' }), _jsx(Renderer_RunAction, { action: async () => {
                                // @ts-ignore
                                const sessionData = ModuleFE_Session.sessionData;
                                this.logInfo('Session Data', sessionData);
                                this.closeMenu();
                            }, label: 'Session Data' }), _jsx(Renderer_RunAction, { action: () => {
                                this.closeMenu();
                                ModuleFE_AdvisorSettings.toggleLogger();
                            }, label: 'Toggle logger' }), _jsx(Renderer_RunAction, { action: async () => {
                                Toaster_AdvisorGeneral.toastGeneral({
                                    title: 'Advisor Toasting Test',
                                    body: 'TEST TEST TEST TEST TEST',
                                    duration: 200 * Second,
                                });
                                this.closeMenu();
                            }, label: 'Test General Toast' }), _jsx(Renderer_RunAction, { action: () => {
                                this.closeMenu();
                                ModuleFE_AdvisorSettings.floodMemory();
                            }, label: 'Flood Memory' }), _jsx(Renderer_RunAction, { action: () => {
                                this.closeMenu();
                                ModuleFE_Spotlight.openSurvey();
                            }, label: 'Open Survey' }), _jsx(Renderer_RunAction, { action: () => {
                                this.closeMenu();
                                Dialog_DBExplorer.show();
                            }, label: 'DB Explorer' }), _jsx(Renderer_RunAction, { action: () => {
                                this.closeMenu();
                                ModuleFE_AdvisorSession.debug_SetLastSeenAt(100);
                                ModuleFE_Recap.forceRecalcFeedItems();
                                Dialog_Recap.show();
                            }, label: 'Force Recap' })] }), _jsx(Renderer_RowWrapper, { label: 'Encounter ID', direction: 'Horizontal', children: _jsx("div", { style: { cursor: 'pointer' }, onClick: () => {
                            this.logWarning(`Current Encounter ID: '${ModuleFE_AdvisorSession.getCurrentEncounterId()}'`);
                            ModuleFE_EncounterMetadata.getEncounterMetadata();
                        }, className: 'selectable-value', children: ModuleFE_AdvisorSession.getCurrentEncounterId() }) })] });
    };
    renderWorkspaceTests = () => {
        if (this.state.readonly)
            return;
        return _jsxs(Renderer_RowWrapper, { direction: 'Vertical', label: 'Workspace Tests', children: [panelModes.map((mode => _jsx(Renderer_RunAction, { label: mode.label, action: () => this.setWorkspace(mode.key, mode.type) }, mode.label))), _jsx(Renderer_RunAction, { label: 'Make It Dance!!!', action: () => {
                        this.closeMenu();
                        makeItDance();
                    } })] });
    };
    //######################### Render - AB Testing #########################
    render_ABTesting = () => {
        const advisorConfig = ModuleFE_AdvisorSession.getAdvisorConfig();
        return _jsx(TS_CollapsableContainer, { flipHeaderOrder: true, customCaret: _jsx(ICONS.advisor_v4_arrow.component, {}), headerRenderer: () => _jsx(_Fragment, { children: "AB Testing" }), containerRenderer: () => _jsxs(LL_V_L, { className: 'match_parent', children: [this.render_AB_PertinentData(advisorConfig), this.render_AB_MagicWand(advisorConfig)] }) });
    };
    render_AB_PertinentData = (advisorConfig) => {
        const current = ModuleFE_AdvisorABTesting.getValue('pertinentData');
        const disabled = !exists(current.abValue) || current.abValue === ABTestValue.Disabled;
        return _jsx(Renderer_RowWrapper, { direction: 'Horizontal', label: 'Pertinent Data', children: _jsx(TS_Toggle, { disabled: disabled, checked: disabled ? false : current.actualValue, onCheck: () => {
                    ModuleFE_AdvisorABTesting.setValue('pertinentData', !current.actualValue);
                    this.forceUpdate();
                } }) });
    };
    render_AB_MagicWand = (advisorConfig) => {
        const current = ModuleFE_AdvisorABTesting.getValue('magicWand');
        const disabled = !exists(current.abValue) || current.abValue === ABTestValue.Disabled;
        return _jsx(Renderer_RowWrapper, { direction: 'Horizontal', label: 'Magic Wand', children: _jsx(TS_Toggle, { checked: disabled ? false : current.actualValue, disabled: disabled, onCheck: () => {
                    ModuleFE_AdvisorABTesting.setValue('pertinentData', !current.actualValue);
                    this.forceUpdate();
                } }) });
    };
}
//# sourceMappingURL=Menu_AdvisorSettings.js.map